import React,{useState} from 'react'
import CategoryVarietyCard2 from './CategoryVarietyCard2'
import {BsChevronDown} from 'react-icons/bs';
import {BsChevronUp} from 'react-icons/bs';

const CategoryVarietyCard = ({Image}) => {
  const [show,setShow]=useState('hidden');
  const ShowAction=()=>{
      if(show==='hidden'){
          setShow('block');
      }else{
          setShow('hidden');
      }
  }
  return (
    <div className=' mb-0.5 lg:mb-2 '>
        <div onClick={ShowAction} className='flex w-full items-center py-2 bg-white hover:cursor-pointer rounded-sm '>

          <div className='p-2 w-24 md:w-32'><img src={Image} alt="" /></div>
          <div className='px-2 overflow-hidden w-full '>
              <h1 className='text-lg font-bold relative'>Grocceries <BsChevronDown className={`absolute top-2 lg:top-0 right-2 ${show=='hidden'?'block':'hidden'} `}/> <BsChevronUp className={`absolute top-0 right-2 ${show} `}/> </h1>
              <p className=' overflow-hidden pr-8 md:whitespace-normal  truncate py-1 text-gray-600  text-sm font-semibold'>
              {(`Fruits & Vegetables,`)} Premium Fruits, Dairy & Bakery, Staples, Snacks & Branded Foods, Beverages, Personal Care, Home Care, Apparel, Mom & Baby Care, Books, Pets
              </p>
          </div>
        </div>
        
        <div className={`${show} md:py-1 bg-gray-100 px-1 md:px-2`} >
            <CategoryVarietyCard2 Image={'/images/Groccery/Fruite1.png'} Content={["Fresh Fruits",'Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']} />
            <CategoryVarietyCard2 Image={'/images/Groccery/PremiumFruites.png'} Content={['Fresh Fruits','Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']}/>
            <CategoryVarietyCard2 Image={'/images/Groccery/Diarybakery.png'} Content={['Fresh Fruits','Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']}/>
            <CategoryVarietyCard2 Image={'/images/Groccery/Staples.jpg'} Content={['Fresh Fruits','Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']}/>
            <CategoryVarietyCard2 Image={'/images/Groccery/Snacks&Brandedfood.png'} Content={['Fresh Fruits','Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']}/>
            <CategoryVarietyCard2 Image={'/images/Groccery/Homecare.png'} Content={['Fresh Fruits','Fresh Vegetables','Herbs & Seasonings','Exotic Fruits & Vegetables','Atta, Flours & Sooji','Dals & Pulses','Rice & Rice Products','Edible Oils','Masalas & Spices','Salt, Sugar & Jaggery']}/>
        </div>

    </div>
  )
}

export default CategoryVarietyCard